import { render, staticRenderFns } from "./transferstore.vue?vue&type=template&id=e5ba3b2e&scoped=true&"
import script from "./transferstore.vue?vue&type=script&lang=js&"
export * from "./transferstore.vue?vue&type=script&lang=js&"
import style0 from "./transferstore.vue?vue&type=style&index=0&id=e5ba3b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ba3b2e",
  null
  
)

export default component.exports